<template>
  <div id="app">
    <div class="title-container">
      <h2 v-if="title !== ''">中奖结果：{{ title }}</h2>
    </div>
    <LuckyWheel
      ref="myLucky"
      width="400px"
      height="400px"
      :prizes="prizes"
      :blocks="blocks"
      :buttons="buttons"
      @start="startCallback"
      @end="endCallback"
    />
  </div>
</template>

<script>
export default {
  name: "LuckyWheelDemo",
  data() {
    return {
      blocks: [{ padding: "13px", background: "#617df2" }],
      prizes: [
        { fonts: [{ text: "电脑", top: "10%" }], background: "#e9e8fe" },
        { fonts: [{ text: "手机", top: "10%" }], background: "#b8c5f2" },
        { fonts: [{ text: "平板", top: "10%" }], background: "#e9e8fe" },
        { fonts: [{ text: "耳机", top: "10%" }], background: "#b8c5f2" },
        { fonts: [{ text: "数据线", top: "10%" }], background: "#e9e8fe" },
        { fonts: [{ text: "优惠券", top: "10%" }], background: "#b8c5f2" },
      ],
      buttons: [
        { radius: "50px", background: "#617df2" },
        { radius: "45px", background: "#afc8ff" },
        {
          radius: "40px",
          background: "#869cfa",
          pointer: true,
          fonts: [{ text: "开始\n抽奖", top: "-20px" }],
        },
      ],
      title: "",
    };
  },
  methods: {
    // 点击抽奖按钮会触发start回调
    startCallback() {
      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play();
      // 模拟调用接口异步抽奖
      setTimeout(() => {
        // 假设后端返回的中奖索引是0
        const index = Math.floor(Math.random() * this.prizes.length);
        // 调用stop停止旋转并传递中奖索引
        this.$refs.myLucky.stop(index);
      }, 3000);
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      const fonts = prize.fonts;
      if (Array.isArray(fonts)) {
        const firstFontText = fonts[0].text;

        // 显示奖品内容
        this.title = firstFontText;
        console.log(prize);
      } else {
        // 如果 fonts 不是一个数组，可以尝试直接获取 text 属性
        const fontText = fonts.text;
        this.title = fontText;
        console.log(prize);
      }
    },
  },
};
</script>
<style scoped>
#app {
  display: flex;
  flex-direction: column; /* 改为垂直布局 */
  align-items: center;
  width: 80vh;
  height: 90vh; /* 设置容器高度为视口高度 */
  background-color: white; /* 设置背景颜色 */
}
.title-container {
  text-align: center; /* 居中文本 */
  margin-bottom: 20px; /* 与大转盘之间的间距 */
}
</style>